import {Component, input}  from '@angular/core';
import {CaffRecordLogIntf} from '@djsharkk/logr-types';
import {DialogEditBase}    from '../dialog-edit-base';

@Component({
			   selector   : 'app-dialog-edit-caff',
			   imports    : [],
			   templateUrl: './dialog-edit-caff.component.html',
			   styleUrl   : './dialog-edit-caff.component.css'
		   })
export class DialogEditCaffComponent extends DialogEditBase<CaffRecordLogIntf> {
	rec = input.required<CaffRecordLogIntf>();
}
